import React from "react";
import PropTypes from "prop-types";
import "react-dropdown/style.css";
import { ChoVayCombo } from "constants/choVayConst";
import ReactDropdown from "react-dropdown";
import Layout from "containers/Layout";
import AddOrEditStore from "containers/DanhSachKho/SubContainers/addOrEditStore";
import ItemStore from "./ItemStore";
import StoreDelete from "containers/DanhSachKho/SubContainers/StoreDelete";
import LayoutV2 from "containers/LayoutV2";
import UserApi from "service/userApi";
class DanhSachKho extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showThemMoiKho: false,
      dataSearch: {
        storeName: "",
        storeAddress: "",
        storeStatus: null,
      },
      storeEdit: null,
      dsQuyen: null,
    };
  }
  componentDidMount() {
    document.title = "Danh sách kho | Phần mềm quản lý cầm đồ Morman";
    UserApi.getAllQuyen()
      .then((res) => {
        const dsQuyen =
          res.status === 200 && Array.isArray(res.data)
            ? res.data.map((item) => (item.ModuleCode || "").toLowerCase())
            : [];
        this.setState({ dsQuyen });
        if (dsQuyen.includes("danhsachkho")) {
          this.loadDanhSachKho(this.state.dataSearch);
        }
      })
      .catch(() => this.setState({ dsQuyen: [] }));
  }
  componentDidUpdate(prevProps, prevState) {
    let { dataSearch } = this.state;
    let { addoreditstore, deletestore } = this.props;
    if (
      prevProps.addoreditstore.isShowModalStore !==
        addoreditstore.isShowModalStore ||
      deletestore.isShowDelModalStore !==
        prevProps.deletestore.isShowDelModalStore
    ) {
      this.loadDanhSachKho(dataSearch);
    }
  }
  loadDanhSachKho(dataSearch) {
    let { getListDanhSachKho } = this.props;
    getListDanhSachKho(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  setModalDeleteStoreShow = (data) => () => {
    let { dataSearch } = this.state;
    let { showDeleteModalStore, deletestore } = this.props;
    this.setState({
      storeEdit: data,
    });
    showDeleteModalStore(data);
    if (deletestore.isShowDelModalStore) {
      this.loadDanhSachKho(dataSearch);
    }
  };
  setModalThemMoiKhoShow = (data) => () => {
    let { dataSearch } = this.state;
    let { showModalStore, deletestore } = this.props;
    this.setState({
      storeEdit: data,
    });
    showModalStore(data);
    if (deletestore.isShowModalStore) {
      this.loadDanhSachKho(dataSearch);
    }
  };
  renderTableRows() {
    let { danhsachkho } = this.props;
    let { dsQuyen } = this.state;
    return danhsachkho.objList.map((item, index) => (
      <ItemStore
        item={item}
        onEdit={this.setModalThemMoiKhoShow(item)}
        idx={index}
        onDelete={this.setModalDeleteStoreShow(item)}
        quyenSua={dsQuyen.includes("danhsachkho_suakho")}
        quyenXoa={dsQuyen.includes("danhsachkho_xoakho")}
      ></ItemStore>
    ));
  }
  onChangeData = (field) => (event) => {
    let { dataSearch } = this.state;
    dataSearch[field] = event.target.value;
    this.setState({ dataSearch });
  };
  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadDanhSachKho(dataSearch);
    }
  };
  _onSelect = (field) => (value) => {
    let { dataSearch } = this.state;
    dataSearch[field] = value.value;
    this.setState({ dataSearch });
  };
  onSearch = () => {
    let { dataSearch } = this.state;
    this.loadDanhSachKho(dataSearch);
  };
  render() {
    let { dataSearch, storeEdit, dsQuyen } = this.state;

    if (dsQuyen === null) return <LayoutV2></LayoutV2>;

    if (!dsQuyen.includes("danhsachkho")) {
      return (
        <LayoutV2>
          <h2 className="text-danger">
            <div className="custom-table-row">
              <div
                className="custom-table-cell text-center red"
                style={{ width: "100%" }}
              >
                Bạn không có quyền truy cập trang này!
              </div>
            </div>
          </h2>
        </LayoutV2>
      );
    }

    let { storeName, storeAddress, storeStatus } = dataSearch;
    let { danhsachkho, addoreditstore, deletestore } = this.props;
    let { isShowModalStore } = addoreditstore;
    let { isShowDelModalStore } = deletestore;
    return (
      <LayoutV2>
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-quan-ly-tai-san.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Danh sách kho</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <div className="search-new hidden-mobile-main show-table-main">
                      <div className="input-sm-new input-new-25">
                        <label className="font-color-default font-bold">
                          Tên kho
                        </label>
                        <input
                          type="text"
                          className="form-control input-sm"
                          placeholder="Tên kho"
                          value={storeName}
                          onChange={this.onChangeData("storeName")}
                          onKeyDown={this.handleKeyDown}
                        />
                      </div>

                      <div className="input-sm-new input-new-18">
                        <label className="font-color-default font-bold">
                          Địa chỉ kho
                        </label>
                        <input
                          type="text"
                          className="form-control input-sm"
                          placeholder="Địa chỉ kho"
                          value={storeAddress}
                          onKeyDown={this.handleKeyDown}
                          onChange={this.onChangeData("storeAddress")}
                        />
                      </div>

                      <div className="input-sm-new input-new-18">
                        <label className="font-color-default font-bold">
                          Trạng thái
                        </label>
                        <ReactDropdown
                          options={ChoVayCombo.TrangThaiKhoCombo}
                          placeholder="-- Trạng thái --"
                          controlClassName="form-control input-sm"
                          onChange={this._onSelect("storeStatus")}
                          value={storeStatus}
                        />
                      </div>

                      <div
                        className="input-sm-new input-new-18 search-main-new"
                        style={{ marginTop: "28px" }}
                      >
                        <button
                          type="submit"
                          className="btn btn-info-new"
                          onClick={this.onSearch}
                        >
                          <i className="la la-search"></i>
                          <span> &nbsp; Tìm kiếm</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="camdo-home">
                <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
                  <div data-repeater-list="car">
                    <div data-repeater-item className="">
                      <form className="form row bg-search-form form-mobile-search">
                        <div className="mb-1 ">
                          {dsQuyen.includes("danhsachkho_themmoikho") && (
                            <button
                              type="button"
                              className="btn btn-border-new"
                              onClick={this.setModalThemMoiKhoShow(null)}
                            >
                              <img
                                src="/app-assets/images/icon-them-moi-cam-do-v2.png"
                                style={{ paddingBottom: "5px" }}
                              />{" "}
                              Thêm mới
                            </button>
                          )}
                        </div>

                        <div className="text-right left-search search-p mb-1 ">
                          <div className="search-mobile-new">
                            <fieldset className="form-group position-relative mb-0">
                              <input
                                type="text"
                                className="form-control input-sm"
                                id="iconLeft1"
                                placeholder="Tên, địa chỉ kho ..."
                              />
                              <div className="form-control-position">
                                <i className="mdi mdi-magnify"></i>
                              </div>
                            </fieldset>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="card border-light mb-3 card-v2"
            style={{
              marginLeft: "15px",
              marginRight: "15px",
            }}
          >
            <div className="card-body card-body-v2">
              <div className="iconbutton-new hidden-mobile-main show-table-main">
                <div className="row">
                  <div className="col-sm-12 col-md-9">
                    {dsQuyen.includes("danhsachkho_themmoikho") && (
                      <button
                        type="button"
                        className="btn btn-border-new"
                        onClick={this.setModalThemMoiKhoShow(null)}
                      >
                        <i className="mdi mdi-plus"></i> Thêm mới
                      </button>
                    )}
                  </div>
                  <div className="col-sm-12 col-md-3 d-flex just-end"></div>
                </div>
              </div>
              <br />
              <div className="Left808x200 Table-main-new">
                <div className="table-mobile  table-mobile-hover">
                  <div className="custom-table-wrapper">
                    <div className="table-headers">
                      <div className="custom-table-header flex-basis-5 flex-basis-5-sm">
                        <p className="text-center">
                          STT
                          <br />{" "}
                          <span className="color-do-bold">
                            [{danhsachkho.objList.length}]
                          </span>
                        </p>
                      </div>
                      <div className="custom-table-header flex-basis-25 flex-basis-25-sm">
                        <p className="text-center">Tên kho</p>
                      </div>

                      <div className="custom-table-header flex-basis-45 flex-basis-45-sm">
                        <p className="text-center">Địa chỉ</p>
                      </div>
                      <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                        <p className="tab-header text-center">Trạng thái</p>
                      </div>
                      <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                        <p className="tab-header  text-left">Chức năng</p>
                      </div>
                    </div>

                    <div className="custom-table-body">
                      {this.renderTableRows()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isShowModalStore && (
          <AddOrEditStore
            show={isShowModalStore}
            data={storeEdit}
            onHide={this.setModalThemMoiKhoShow(null)}
          ></AddOrEditStore>
        )}
        {isShowDelModalStore && (
          <StoreDelete
            data={storeEdit}
            onHide={this.setModalDeleteStoreShow(null)}
          ></StoreDelete>
        )}
      </LayoutV2>
    );
  }
}

DanhSachKho.propTypes = {
  getList: PropTypes.func,
};

export default DanhSachKho;
